<template>
  <div class="all_part">
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top">
          <!-- <div>
            <el-input
              v-model="company_Code"
              placeholder="公司代码"
              style="width: 290px"
            ></el-input>
          </div> -->
          <!-- <div>
            <el-input
              v-model="document_date"
              placeholder="凭证日期"
              style="width: 290px"
            ></el-input>
          </div> -->
          <div>
            <el-input
              v-model="name"
              placeholder="客户/客户简称"
              style="width: 290px"
            ></el-input>
          </div>
          <div>
            <el-input
              v-model="be_overdue"
              placeholder="逾期天数(正数为逾期，负数为未到期)"
              style="width: 290px"
            ></el-input>
          </div>
          <div class="submit_button">
            <div class="search_buttons">
              <div class="sousuoButton">
                <el-button
                  type="primary"
                  @click="serchFinanceinfo"
                  style="
                    height: 48px;
                    width: 144px;
                    margin-left: 20px;
                    font-size: 16px;
                  "
                  >搜索
                </el-button>
                <div class="icon_sou">
                  <img src="../assets/SouSuo.png" alt="" width="14px" />
                </div>
              </div>
            </div>

            <div class="all_second_button">
              <div class="ChongZhi">
                <div class="second_button" @click="clearInput">
                  <el-button
                    plain
                    type="primary"
                    style="width: 92px; height: 48px; font-size: 16px"
                    >重置
                  </el-button>
                </div>
                <div class="icon_chong">
                  <img src="../assets/ChongZhi.png" alt="" width="14px" />
                </div>
              </div>
              <div class="second_button" @click="clearInput">
                <div class="Fanhu">
                  <div>
                    <el-button
                      plain
                      type="primary"
                      style="width: 92px; height: 48px"
                      @click="back_menu"
                      >返回
                    </el-button>
                  </div>
                  <div class="icon_fan">
                    <img src="../assets/FanHui.png" alt="" width="14px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table">
      <div>
        <el-table
            border
          :data="tableData.data"
          style="width: 100%"
          height="100%"
          :row-style="{ height: '70px' }"
        >
          <el-table-column fixed label="编号" width="100" type="index">
          </el-table-column>
          <el-table-column prop="name" label="客户" width="120">
          </el-table-column>
          <el-table-column prop="full_name" label="客户全称" width="290">
          </el-table-column>
          <el-table-column prop="salesman" label="销售人员" width="120">
          </el-table-column>
          <el-table-column prop="accounting_period" label="SAP系统账期" width="120">
          </el-table-column>
          <el-table-column prop="description" label="到账说明" width="230">
          </el-table-column>
          <el-table-column prop="term_of_payment" label="付款条件" width="120">
          </el-table-column>
          <el-table-column prop="money" label="本币金额" width="120">
          </el-table-column>
          <el-table-column prop="invoice_number" label="发票号码" width="180">
          </el-table-column>
          <el-table-column
              prop="payment_due_date"
              label="货款到期日"
              width="120"
          >
          </el-table-column>
          <el-table-column prop="be_overdue" label="逾期天数" width="120">
          </el-table-column>
          <el-table-column prop="courier_number" label="快递单号" width="220">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="block">
      <el-pagination
        background
        page-size="20"
        layout="prev, pager, next"
        :total="tableData.total"
        hide-on-single-page="true"
        @current-change="reflash"
      >
      </el-pagination>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>
<script>
import { httpUrl } from "../components/publics";
import titleBlock_computer from "../views/titleBlock_computer.vue";

export default {
  data() {
    return {
      be_overdue: "",
      PanDuanShou: false,
      pageStats: "",
      tableData: [],
      company_Code: "",
      document_date: "",
      name: "",
      full_name: "",
      page: "",
    };
  },
  mounted() {
    this.serchFinanceinfo();
  },
  components: {
    titleBlock_computer,
  },
  methods: {
    back_menu() {
      this.$router.push("/Main_menuComputer");
    },
    inputShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    clearInput() {
      this.be_overdue = "";
      this.company_Code = "";
      this.document_date = "";
      this.name = "";
      this.full_name = "";
    },
    reflash(val) {
      this.page = val;
      this.serchFinanceinfo();
    },
    serchFinanceinfo() {
      // if (this.name == "" && this.be_overdue == "") {
      //   this.$message("请输入信息进行查询");
      //   return;
      // }
      let user = JSON.parse(sessionStorage.getItem('user'));
      this.axios
        .get(
          httpUrl +
            `/api/index/finance?name=${this.name}&be_overdue=${this.be_overdue}&page=${this.page}&user_id=${user.id}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.tableData = response.data.data;
            console.log(this.tableData.data);
          }
          this.$message(response.data.message);
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
  },
};
</script>

<style>
.cell {
  text-align: center;
}
.el-table__row {
  background-image: url("../assets/table_logo.png");
}
</style>
<style scoped>
.all_part {
  min-width: 1920px;
  min-height: 925px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.all_input {
  display: flex;
  flex-direction: row;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  align-items: center;
}

.table {
  height: 70%;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
}

.all_input_top div {
  margin-left: 10px;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  padding: 0 20px;

  display: flex;
  flex-direction: row;
}

.all_second_button {
  display: flex;
  flex-direction: row;
}

.second_button {
  margin-left: 20px;
}

.Copyright_information {
  margin-bottom: 15px;
}

.block {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  align-items: center;
  height: 50px;
}
.all_Kong {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 0 20px;
}
.sousuoButton {
  position: relative;
}
.icon_sou {
  top: 16px;
  left: 32px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 12px;
  position: absolute;
}
.ShouQi {
  position: relative;
}
.icon_Shou {
  top: 14px;
  left: 12px;

  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}
.Fanhu {
  position: relative;
}
</style>